import { isFunction, noop } from 'lodash';

/**
 * @type {class}
 * @desc This task performs an action to return some results or create a side effect.
 * @example
 * import { DynamicQueueTask } from 'tasks/DynamicQueue';
 *
 * functionality reference : https://github.com/hyurl/dynamic-queue
 *
 * // use
 * const dynamicQueueTask = DynamicQueueTask;
 * const result = await dynamicQueueTask.actionName();
 */
export class DynamicQueueTask {


  static queue = [];
  static pendingPromise = false;
  static stop = false;

  static onNewtask = () => noop;

  /**
   * @desc This constructor initializes values for the object.
   */
  constructor( task ) {

    this.tasks = [];
    this.onNewTask = null;
    task && this.tasks.push( task );

    this.__bind();

    this.run();
  }

  __bind() {
    this.push = this.push.bind( this );
    this.length = this.length.bind( this );
    this.run = this.run.bind( this );
    this.handleError = this.handleError.bind( this );
  }

  length() {
    return this.tasks.length;
  }

  push( newTask ) {

    if( !isFunction( newTask ) ) {
      throw new TypeError( 'task must be a function' );
    }

    this.tasks.push( newTask );

    if ( this.onNewTask ) {
      const fn = this.onNewTask;
      this.onNewTask = null;
      fn();
    }

    return this;

  }

    /** Runs tasks one by one in series. */
    run() {
      if ( this.tasks.length ) {
          const task = this.tasks.shift();

          if ( task.length ) {
              try {
                  task( () => this.run() );
              } catch ( err ) {
                  this.handleError( err );
              }
          } else {
              let res;
              try {
                  res = task();
              } catch ( err ) {
                  this.handleError( err );
              }

              if ( res ) {
                  if ( res instanceof DynamicQueueTask ) {
                      if( !res.onError ) {
                        res.onError = this.onError;
                        res.push( ( next ) => {
                            this.push( () => next() ).run();
                        } );
                      }
                  } else if ( isFunction( res.then ) ) {
                      res.then( () => this.run() ).catch( err => {
                          this.handleError( err );
                      } );
                  }
              } else {
                  this.run();
              }
          }
      } else if ( !this.onNewTask ) {
          this.onNewTask = () => this.run();
      }
  }

  handleError( err ) {
    if ( this.onError ) {
      console.log( err );

        // this.onError( err );
    } else {
      console.log( err );

        // throw err;
    }
}

}
